import UserQ from '@/queries/UserQ'
import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'

import useEditPhoneNumberModal from '@/components/Profile/useEditPhoneNumberModal'

import { Priority, type TodoItem } from '../types'

export function useAccountTodos(): TodoItem[] {
  const currentUser = useUser()
  const query = useQuery()

  const [editPhoneNumberModal, showEditPhoneNumberModal] = useEditPhoneNumberModal({
    type: 'add',
  })

  const user = query.one(UserQ.where({ id: currentUser.id }))
  const hasPhoneNumber = user(UserQ.phone_number) != null

  const todos: TodoItem[] = []

  const phoneNumberItem: TodoItem = {
    title: 'Add your phone number',
    subtitle: 'To receive important notifications',
    completed: hasPhoneNumber,
    onClick: () => showEditPhoneNumberModal({}),
    priority: Priority.High,
    emoji: '📞',
    additionalComponent: () => editPhoneNumberModal,
  }

  todos.push(phoneNumberItem)

  return todos
}
